module.exports = __webpack_public_path__ + "media/images/star_full_icon-71271726.png";